/* eslint-disable @typescript-eslint/naming-convention */
import * as _ from 'lodash';
import { useState } from 'react';

type PortalSettingsState = {
  state: {
    pendingAddTokenIds: number[];
    pendingRemoveTokenIds: number[];
    publicOnPortal: boolean;
  },
  actions: {
    onAddToken: (tokenId: number) => void;
    onRemoveToken: (tokenId: number) => void;
    setPublicOnPortal: (value: boolean) => void;
    onReset: () => void;
  }
};

/**
 * Hook to manage the state of the portal settings
 */
const usePortalSettingsState = (initialIsPublicOnPortal: boolean = false): PortalSettingsState => {
  const [pendingAddTokenIds, setPendingAddTokenIds] = useState<number[]>([]);
  const [pendingRemoveTokenIds, setPendingRemoveTokenIds] = useState<number[]>([]);
  // publicOnPortal should be false by default to prevent accidental public release groups
  const [publicOnPortal, setPublicOnPortal] = useState<boolean>(initialIsPublicOnPortal);

  const onAddToken = (tokenId: number) => {
    setPendingAddTokenIds((prev) => _.uniq([...prev, tokenId]));
  };

  const onRemoveToken = (tokenId: number) => {
    setPendingAddTokenIds((prev) => prev.filter((id) => id !== tokenId));
    setPendingRemoveTokenIds((prev) => _.uniq([...prev, tokenId]));
  };

  const onReset = () => {
    setPendingAddTokenIds([]);
    setPendingRemoveTokenIds([]);
  };

  return {
    state: {
      pendingAddTokenIds,
      pendingRemoveTokenIds,
      publicOnPortal,
    },
    actions: {
      onAddToken,
      onRemoveToken,
      setPublicOnPortal,
      onReset,
    },
  };
};

export default usePortalSettingsState;
